import { isString } from '@benzinga/utils';

export const canShowMorty = (
  fico_rating: string,
  property_use: string,
  loan_type: string,
  abbreviation: string,
): boolean => {
  if (fico_rating !== 'fair' && property_use === 'primary' && loan_type === 'purchase') {
    if (abbreviation)
      return [
        'AL',
        'AR',
        'CA',
        'CO',
        'CT',
        'DC',
        'DE',
        'FL',
        'GA',
        'IA',
        'IL',
        'IN',
        'KS',
        'KY',
        'MD',
        'MI',
        'MN',
        'MS',
        'NC',
        'NE',
        'NJ',
        'NM',
        'NY',
        'OH',
        'OK',
        'OR',
        'PA',
        'SC',
        'TN',
        'VA',
        'WA',
        'WI',
      ].includes(abbreviation);
  }
  return false;
};

export const canShowFigureRefi = (abbreviation: string): boolean => {
  if (abbreviation) {
    return [
      'AK',
      'AL',
      'AR',
      'AZ',
      'CA',
      'DE',
      'FL',
      'GA',
      'IA',
      'ID',
      'IN',
      'KS',
      'LA',
      'MA',
      'MI',
      'MO',
      'MS',
      'MT',
      'NC',
      'ND',
      'NE',
      'NH',
      'NJ',
      'NM',
      'NV',
      'OH',
      'OK',
      'OR',
      'PA',
      'SD',
      'TN',
      'WA',
      'WI',
      'WV',
    ].includes(abbreviation);
  }
  return false;
};

export const canShowHSH = (): boolean => {
  return true;
};

export const canShowNewAmericanFunding = (): boolean => {
  return true;
};

export const textValue = (value: string | number): string => {
  const val = isString(value) ? parseInt(value, 10) : value;

  if (val === 1) {
    return 'Under $10,000';
  }

  if (val < 40) {
    return getPeriodLabel(value, 1e4);
  } else if (val < 70) {
    return getPeriodLabel(value, 2e4);
  } else if (val < 75) {
    return '$1-1.5M';
  }

  return `$2M+`;
};

export const numberValue = (value: string | number): number => {
  const val = isString(value) ? parseInt(value, 10) : value;

  if (val === 1) return 10000;

  if (val < 40) {
    return val * 1e4;
  } else if (val < 70) {
    return 40 * 1e4 + (val - 40) * 2e4;
  } else if (val < 75) {
    return 1.5 * 1e6;
  }

  return 2 * 1e6;
};

export const getPeriodLabel = (val: string | number, step: number): string => {
  const start = numberValue(val);
  const end = start + step;
  return `$${start.toLocaleString()} - $${end.toLocaleString()}`;
};

export const getPathFromURL = (): string => {
  return window.location.pathname;
};
